import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeatureFlagRepository } from './feature-flag.repository';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService{
  constructor(
        private featureFlagRepo: FeatureFlagRepository,
  ) {}

  public getAll(): Observable<Array<string>> {
    return this.featureFlagRepo.getAll();
  }
}